module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('ed-alert', {
    staticClass: "mb-2",
    attrs: {
      "title": "Atenção",
      "type": "warning",
      "description": "As tabelas listadas abaixo fazem referência as tabelas de riscos químicos, físicos e biológicos nos documentos do LTCAT. Aqui você pode cadastrar os modelos customizados dessas tabelas."
    }
  }), _vm._v(" "), _c('ed-modal', {
    attrs: {
      "modal": _vm.showHtml,
      "width": "60%"
    }
  }, [_c('div', {
    attrs: {
      "slot": "modal-content"
    },
    slot: "modal-content"
  }, [_c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.formData.html)
    }
  })])]), _vm._v(" "), _c('ed-table', {
    attrs: {
      "registerName": "Inserir Tabela Dinâmica",
      "onRegister": this.$root.$session.validarPermissao(571) ? _vm.onRegister : null,
      "onEdit": _vm.onEdit,
      "onDelete": _vm.onDelete,
      "onSearch": _vm.getTabelaDinamica,
      "tableHead": _vm.tableHead,
      "tableData": _vm.tableData,
      "loadingTable": _vm.loadingTable,
      "loadingEditAll": _vm.loadingEditAll,
      "pagination": _vm.pagination,
      "response": _vm.response
    }
  }, [_c('div', {
    attrs: {
      "slot": "table-export"
    },
    slot: "table-export"
  }, [(_vm.tableData.length) ? _c('ed-button', {
    attrs: {
      "icon": "fa fa-download",
      "type": "text",
      "label": "Exportar Tabelas",
      "title": "Clique aqui para exportar as tabelas e visualizar a extrutura das colunas"
    },
    on: {
      "click": _vm.onExportar
    }
  }) : _vm._e()], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-288a23d9"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/apps/web/ltcat/tabela-dinamica/index.vue
// module id = 1433
// module chunks = 45